<template>
  <div class="components-cus-upload-img">
    <el-upload
      list-type="picture-card"
      :action="uploadUrl"
      :show-file-list="false"
      name="image"
      accept=".png,.jpeg,.jpg,.gif"
      ref="iconImgRef"
      class="box"
      :headers="uploadHeaders"
      :data="uploadExtraData"
      :limit="limit"
      :multiple="multiple"
      :on-success="
        (res, file, fileList) => {
          return handleAvatarSuccess(res, file, fileList, 'people_face');
        }
      "
      :before-upload="beforeAvatarUpload"
      :style="{ width: `${imgWidth}px`, height: `${imgWidth}px` }"
    >
      <img
        v-if="thumb_str"
        :src="thumb_str"
        :style="{ width: `${imgWidth}px`, height: `${imgWidth}px` }"
      />

      <div
        v-else
        class="icon-box"
        :style="{ width: `${imgWidth}px`, height: `${imgWidth}px` }"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </div>

      <div
        v-show="thumb_str"
        class="shadow column-center column"
        :style="{ width: `${imgWidth}px`, height: `${imgWidth}px` }"
        @click.stop=""
      >
        <div class="box">
          <i
            class="el-icon-zoom-in el-icon-style"
            @click.stop="previewImg()"
          ></i>
          <i
            v-if="isDel"
            class="el-icon-delete el-icon-style"
            @click.stop="delImg()"
          ></i>
        </div>
      </div>
    </el-upload>
    <el-dialog
      :visible.sync="isPrevie"
      :modal="isModal"
      :append-to-body="true"
      custom-class="components-previe-img"
    >
      <img width="100%" :src="thumb_str" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import constant from "../../service/common/constant";
export default {
  props: {
    f_thumb: {
      type: String,
      default: "",
    },
    f_thumb_str: {
      type: String,
      default: "",
    },
    imgWidth: {
      type: Number,
      default: 100,
    },
    isCompress: {
      type: Boolean,
      default: false,
    },
    isDel: {
      type: Boolean,
      default: true,
    },
    isModal: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [String, Number],
      default: undefined,
    },
    f_data: {
      type: Object,
      default: () => {},
    },
    uploadExtraData: {
      type: Object,
      default: () => {
        return {
          img_type: 4,
          suffix: ".jpg",
        };
      },
    },
  },
  data() {
    return {
      isPrevie: false,
      thumb: "",
      thumb_str: "",

      loading: null,
    };
  },
  computed: {
    srcList() {
      return [this.thumb_str];
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function() {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  watch: {
    f_thumb: {
      handler: function(n, o) {
        this.thumb = n;
        this.thumb_str = this.f_thumb_str;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 删除图片
    delImg() {
      if (!this.isDel) {
        return;
      }
      this.thumb = "";
      this.thumb_str = "";
      // 清空 el-upload 的文件列表，确保可以重新上传
      this.$nextTick(() => {
        if (this.$refs.iconImgRef) {
          this.$refs.iconImgRef.clearFiles();
        }
      });
      let data = {
        pic: "",
        path: "",
      };
      this.$emit("emitImg", data, this.index, true, this.f_data);
    },
    // 预览图片
    previewImg() {
      this.isPrevie = true;
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList, imgname) {
      if (res.code === 0) {
        this.thumb = res.data.pic;
        this.thumb_str = res.data.path;
        res.data.imgname = file.name;
        this.$emit("emitImg", res.data, this.index, false, this.f_data);
      }
      this.loading.close();
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      this.loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const supportImgTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
      ];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg,gif 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      if (!this.isCompress) {
        return true;
      }
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          let width = 750;
          let height = (750 / image.width) * image.height;
          if (!this.isCompress) {
            width = image.width;
            height = image.height;
          }
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.components-cus-upload-img {
  ::v-deep .el-dialog__wrapper {
    .el-dialog__header {
      padding-bottom: 22px !important;
    }
  }

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      height: 0;
    }
  }

  .el-upload-list {
    & > li {
      width: 327px;
      height: 267px;
      border-radius: 24px;
    }
  }
  ::v-deep .el-upload--picture-card {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
  }
  .box {
    position: relative;
    width: 100%;
    &:hover .shadow {
      display: flex;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .shadow {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: none;
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .el-icon-style {
      font-size: 20px;
      text-align: center;
      cursor: pointer;
      color: #fff;
      padding: 0 20px;
    }
  }
}
</style>
<style lang="scss">
.components-previe-img {
  z-index: 99999;
}
</style>
